// Other
import { urlApiGoogle } from '~/utils/constants/apis';
import { IBaseResponse } from '~/utils/interface/base';
import { IQueryGetTokenGoogle, IResponseGetAuthURL } from '~/utils/interface/google';
import { IListGoogleGmailResponse, IQueryGetListGoogleGmail } from '~/utils/interface/email';
import axiosClient from './axiosClient';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const googleGmailApi = {
  getAuthUrl: () => {
    const url = urlApiGoogle.getAuthUrl;
    return axiosClient.get<IBaseResponse<IResponseGetAuthURL>>(url);
  },

  getTokenGoogle(payload: IQueryGetTokenGoogle) {
    const { code } = payload;
    const url = `${urlApiGoogle.getToken(code)}`;
    return axiosClient.get<IBaseResponse>(url);
  },

  connect(params: IQueryGetTokenGoogle) {
    const url = `${urlApiGoogle.connect}`;
    return axiosClient.get<IBaseResponse>(url, {
      params,
    });
  },

  disconnect() {
    const url = `${urlApiGoogle.disconnect}`;
    return axiosClient.post<IBaseResponse>(url);
  },

  getListGoogleGmail(params: IQueryGetListGoogleGmail) {
    const url = urlApiGoogle.getListGmail;
    return axiosClient.get<IBaseResponse<IListGoogleGmailResponse>>(url, { params });
  },

  sendGoogleGmail(body: FormData) {
    const url = `${urlApiGoogle.sendGoogleGmail}`;
    return axiosClient.post<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },
};

export default googleGmailApi;
